.list-item {
  border-radius: 0.4rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem;
  gap: 1.6rem;
  cursor: pointer;
  /* --list-item-width is set inline only when `width` is given; the 100%
     fallback is what the ternary used to produce. */
  min-width: var(--list-item-width, 100%);
  width: var(--list-item-width, 100%);
  max-width: var(--list-item-width, 100%);
  user-select: none;

  &[data-disabled='true'] {
    pointer-events: none;

    & * {
      color: var(--color-grayscale-light-slate);
    }
  }

  &:hover,
  &[data-checked='true'] {
    background: var(--color-grayscale-arsenic, #3c404a);
  }
}

.left {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.tag {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.4em 0.8rem;
  background: var(--color-grayscale-arsenic, #3c404a);
  border-radius: var(--border-radius-medium);
  color: var(--color-grayscale-cadet, #afb4c0);

  /* Captions */
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4rem;
}
